<template>
    <div
        class="m-userStores modal-dialog modal-dialog-centered modal-dialog-scrollable"
        role="document"
    >
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <modal-close />
                <div class="modal-title">
                    <h2 class="h3 pt-1 mb-0">Edytuj godziny otwarcia</h2>
                </div>
            </div>
            <div class="modal-body border-top px-3 py-0">
                <div class="m-userStores__setAllDaysBox row border-bottom">
                    <div class="col-md-3"></div>
                    <div
                        class="m-userStores__setOpeningHours col-md-5 d-flex justify-content-center"
                    >
                        <span class="d-flex">
                            <the-time-picker
                                class="ml-auto mr-2 mb-0"
                                :class="{
                                    error: !validateDayValue(allDaysValue)
                                }"
                                :selected="selectedValue(allDaysValue, 'from')"
                                @change="
                                    onChange(
                                        allDaysValue,
                                        'all',
                                        'from',
                                        $event
                                    )
                                "
                            />
                            <the-time-picker
                                class="mr-2"
                                :class="{
                                    error: !validateDayValue(allDaysValue)
                                }"
                                :selected="selectedValue(allDaysValue, 'to')"
                                word="-"
                                @change="
                                    onChange(allDaysValue, 'all', 'to', $event)
                                "
                            />
                        </span>
                    </div>
                    <div
                        class="col-md-4 d-flex justify-content-center align-items-center"
                    >
                        <the-btn
                            :disabled="
                                !allDaysValue ||
                                    allDaysValue === 'HH:mm' ||
                                    !validateDayValue(allDaysValue)
                            "
                            @click.native="onChangeAll"
                        >Zastosuj dla wszystkich</the-btn>
                    </div>
                </div>
                <div class="py-md-2">
                    <div
                        class="m-userStores__setOpeningHoursBox row d-flex justify-content-between align-items-center"
                        v-for="(dayValue, dayName) in this.setOpeningHours(
                            tmpHours
                        )"
                        :key="dayName"
                    >
                        <span
                            class="col-md-3 col-12 d-flex justify-content-between align-items-end pt-md-2 pb-2 pb-md-0"
                            :class="{ 'text-primary': !isClosed(dayValue) }"
                        >
                            <div class="d-flex">
                                <a-switch
                                    :checked="!isClosed(dayValue)"
                                    class="mr-2 mb-0"
                                    @change="val => onSwitch(val, dayName)"
                                />
                                {{ days[dayName] }}
                            </div>
                            <the-btn
                                class="m-userStores__24HBtn btn d-flex d-md-none"
                                :class="{
                                    'text-gray btn-outline-custom': !is24H(
                                        dayValue
                                    )
                                }"
                                icon="24Hours"
                                @click.native="() => set24H(dayName)"
                            >
                            </the-btn>
                        </span>
                        <div
                            class="m-userStores__setOpeningHours col-md-5 col-12 d-flex justify-content-center"
                        >
                            <span
                                class="d-flex"
                                v-if="!isClosed(dayValue) && !is24H(dayValue)"
                            >
                                <the-time-picker
                                    class="ml-auto mr-2 mb-0"
                                    :class="{
                                        error: !validateDayValue(dayValue)
                                    }"
                                    :selected="selectedValue(dayValue, 'from')"
                                    :drop-direction="dropDirection(dayName)"
                                    @change="
                                        onChange(
                                            dayValue,
                                            dayName,
                                            'from',
                                            $event
                                        )
                                    "
                                />
                                <the-time-picker
                                    class="mr-2"
                                    :class="{
                                        error: !validateDayValue(dayValue)
                                    }"
                                    :selected="selectedValue(dayValue, 'to')"
                                    :drop-direction="dropDirection(dayName)"
                                    word="-"
                                    @change="
                                        onChange(
                                            dayValue,
                                            dayName,
                                            'to',
                                            $event
                                        )
                                    "
                                />
                            </span>
                            <span
                                v-else
                                class="text-primary align-self-center pl-2 pl-md-0"
                                :class="{ 'text-gray': !is24H(dayValue) }"
                            >
                                {{ dayValue }}
                            </span>
                        </div>
                        <div
                            class="col-4 d-md-flex d-none justify-content-center align-items-center"
                        >
                            <the-btn
                                class="btn btn-outline-custom m-userStores__24HBtn"
                                :class="{ 'text-gray': !is24H(dayValue) }"
                                icon="24Hours"
                                @click.native="() => set24H(dayName)"
                            >
                                <span class="d-md-inline d-none">Całodobowy</span></the-btn>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="modal-footer d-flex justify-content-between align-items-center"
            >
                <button
                    type="button"
                    class="btn btn-outline-custom"
                    data-dismiss="modal"
                    @click="closeModal"
                >
                    Anuluj
                </button>
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="onSave"
                    :disabled="disabledSaveBtn"
                >
                    Zapisz
                    <button-spinner
                        class="ml-3"
                        :status="$store.getters.getStoreDataStatus"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import days from '@/dictionaries/days.json'
export default {
    data() {
        return {
            days,
            tmpHours: {},
            allDaysValue: null
        }
    },
    props: {
        setOpeningHours: {
            type: Function,
            default: () => {}
        },
        saveHoursChanges: {
            type: Function,
            default: () => {}
        }
    },
    mounted() {
        this.tmpHours = {
            opening_hours_monday: this.hours.opening_hours_monday,
            opening_hours_tuesday: this.hours.opening_hours_tuesday,
            opening_hours_wednesday: this.hours.opening_hours_wednesday,
            opening_hours_thursday: this.hours.opening_hours_thursday,
            opening_hours_friday: this.hours.opening_hours_friday,
            opening_hours_saturday: this.hours.opening_hours_saturday,
            opening_hours_sunday: this.hours.opening_hours_sunday
        }
    },
    methods: {
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        },
        onSave() {
            this.saveHoursChanges(this.tmpHours)
        },
        onChange(dayHours, dayName, fromTo, event) {
            if (!dayHours) {
                if (fromTo === 'from') {
                    dayHours = event + '-'
                }
                if (fromTo === 'to') {
                    dayHours = '-' + event
                }
            } else {
                if (fromTo === 'from') {
                    dayHours = event + '-' + dayHours.split('-')[1]
                }
                if (fromTo === 'to') {
                    dayHours = dayHours.split('-')[0] + '-' + event
                }
            }
            if (dayHours === '-') dayHours = null
            if (dayName === 'all') {
                this.allDaysValue = dayHours
            } else {
                this.tmpHours['opening_hours_' + dayName] = dayHours
            }
        },
        onChangeAll() {
            for (const [key] of Object.entries(this.tmpHours)) {
                this.tmpHours[key] = this.allDaysValue
            }
            this.allDaysValue = 'HH:mm-HH:mm'
        },
        isClosed(value) {
            return value === 'Nieczynny'
        },
        is24H(value) {
            return value === 'Całodobowy'
        },
        onSwitch($val, dayName) {
            const value = this.hours['opening_hours_' + dayName]

            this.tmpHours['opening_hours_' + dayName] = $val
                ? value === 'closed' || value === '00:00-00:00'
                    ? null
                    : value
                : 'closed'
        },
        set24H(dayName) {
            const value = this.hours['opening_hours_' + dayName]
            const tmpValue = this.tmpHours['opening_hours_' + dayName]

            this.tmpHours['opening_hours_' + dayName] =
                tmpValue === '00:00-00:00'
                    ? value === '00:00-00:00' || value === 'closed'
                        ? null
                        : value
                    : '00:00-00:00'
        },
        dropDirection(dayName) {
            switch (dayName) {
            case 'friday':
            case 'saturday':
            case 'sunday':
                return 'up'
            default:
                return 'down'
            }
        },
        validateDayValue(dayValue) {
            if (
                this.isClosed(dayValue) ||
                this.is24H(dayValue) ||
                !dayValue ||
                dayValue === '-'
            ) {
                return true
            } else {
                return !!dayValue.split('-')[0] && !!dayValue.split('-')[1]
            }
        },
        selectedValue(value, fromTo) {
            const idx = fromTo === 'from' ? 0 : 1
            return value && value !== '-'
                ? value.split('-')[idx]
                    ? value.split('-')[idx]
                    : null
                : null
        }
    },
    computed: {
        openingHours() {
            return this.$store.getters.modalState.args.openingHours
        },
        disabledSaveBtn() {
            return (
                !Object.values(this.setOpeningHours(this.tmpHours)).every(val =>
                    this.validateDayValue(val)
                ) || this.$store.getters.getStoreDataStatus === 'loading'
            )
        },
        hours() {
            return this.$store.getters.modalState.args.hours
        }
    }
}
</script>
